angular.module('core')
    .factory('PhoneNumberFormatter', function () {
        let getLibrary = () => window.libphonenumber

        let normalizeCountryCode = countryCode => (countryCode || 'PL').toUpperCase()

        let isInternationalNumber = value => /^\s*(\+|00)/.test(value || '')

        let isFreeTextValue = value => /[^\d\s+()./-]/.test(value || '')

        let normalizeValue = value => {
            if (value === undefined || value === null) {
                return ''
            }
            return String(value).trim()
        }

        let getCountryCallingCode = countryCode => {
            let libphonenumber = getLibrary()
            if (!libphonenumber || typeof libphonenumber.getCountryCallingCode !== 'function') {
                return null
            }

            try {
                return libphonenumber.getCountryCallingCode(normalizeCountryCode(countryCode))
            } catch (e) {
                return null
            }
        }

        let parsePhoneNumber = (rawValue, countryCode) => {
            let normalizedValue = normalizeValue(rawValue)
            let libphonenumber = getLibrary()
            if (!normalizedValue || isFreeTextValue(normalizedValue) || !libphonenumber || typeof libphonenumber.parsePhoneNumberFromString !== 'function') {
                return null
            }

            try {
                return libphonenumber.parsePhoneNumberFromString(normalizedValue, normalizeCountryCode(countryCode)) || null
            } catch (e) {
                return null
            }
        }

        let formatAsYouType = (rawValue, countryCode = 'PL') => {
            let normalizedValue = normalizeValue(rawValue)
            let libphonenumber = getLibrary()
            if (!normalizedValue || isFreeTextValue(normalizedValue) || !libphonenumber || typeof libphonenumber.AsYouType !== 'function') {
                return normalizedValue
            }

            try {
                return new libphonenumber.AsYouType(normalizeCountryCode(countryCode)).input(normalizedValue) || normalizedValue
            } catch (e) {
                return normalizedValue
            }
        }

        let formatForInput = (rawValue, countryCode = 'PL') => {
            let normalizedValue = normalizeValue(rawValue)
            if (!normalizedValue || isFreeTextValue(normalizedValue)) {
                return normalizedValue
            }

            let parsedPhoneNumber = parsePhoneNumber(normalizedValue, countryCode)
            if (parsedPhoneNumber) {
                let normalizedCountryCode = normalizeCountryCode(countryCode)
                if (parsedPhoneNumber.country === normalizedCountryCode && typeof parsedPhoneNumber.formatNational === 'function') {
                    return parsedPhoneNumber.formatNational()
                }

                if (typeof parsedPhoneNumber.formatNational === 'function' && !isInternationalNumber(normalizedValue)) {
                    return parsedPhoneNumber.formatNational()
                }

                if (typeof parsedPhoneNumber.formatInternational === 'function') {
                    return parsedPhoneNumber.formatInternational()
                }
            }

            if (isInternationalNumber(normalizedValue)) {
                return formatAsYouType(normalizedValue, countryCode)
            }

            return formatAsYouType(normalizedValue, countryCode)
        }

        let formatForDisplay = (rawValue, countryCode = 'PL') => {
            let normalizedValue = normalizeValue(rawValue)
            if (!normalizedValue) {
                return ''
            }

            if (isFreeTextValue(normalizedValue)) {
                return normalizedValue
            }

            let parsedPhoneNumber = parsePhoneNumber(normalizedValue, countryCode)
            if (!parsedPhoneNumber) {
                return formatAsYouType(normalizedValue, countryCode)
            }

            let normalizedCountryCode = normalizeCountryCode(countryCode)
            if (parsedPhoneNumber.country === normalizedCountryCode && typeof parsedPhoneNumber.formatNational === 'function') {
                return parsedPhoneNumber.formatNational()
            }

            if (isInternationalNumber(normalizedValue) && typeof parsedPhoneNumber.formatInternational === 'function') {
                return parsedPhoneNumber.formatInternational()
            }

            if (typeof parsedPhoneNumber.formatNational === 'function') {
                return parsedPhoneNumber.formatNational()
            }

            return formatAsYouType(normalizedValue, countryCode)
        }

        let normalizeForCompare = (rawValue, countryCode = 'PL') => {
            let normalizedValue = normalizeValue(rawValue)
            if (!normalizedValue || isFreeTextValue(normalizedValue)) {
                return ''
            }

            let compactValue = normalizedValue.replace(/[.\s()/-]/g, '')
            if (!compactValue) {
                return ''
            }

            if (compactValue.indexOf('00') === 0) {
                compactValue = `+${compactValue.slice(2)}`
            }

            if (compactValue.indexOf('+') !== 0 && /^\d+$/.test(compactValue)) {
                let countryCallingCode = getCountryCallingCode(countryCode)
                if (compactValue.length === 9 && countryCallingCode) {
                    compactValue = `+${countryCallingCode}${compactValue}`
                } else if (countryCallingCode && compactValue.length === 9 + countryCallingCode.length && compactValue.indexOf(countryCallingCode) === 0) {
                    compactValue = `+${compactValue}`
                } else if (compactValue.length >= 8) {
                    let parsedAsInternationalWithoutPlus = parsePhoneNumber(`+${compactValue}`, countryCode)
                    if (parsedAsInternationalWithoutPlus && parsedAsInternationalWithoutPlus.number) {
                        compactValue = parsedAsInternationalWithoutPlus.number
                    }
                }
            }

            let parsedPhoneNumber = parsePhoneNumber(compactValue, countryCode)
            if (parsedPhoneNumber && parsedPhoneNumber.number) {
                return parsedPhoneNumber.number
            }

            if (/^\+\d+$/.test(compactValue)) {
                return compactValue
            }

            return compactValue
        }

        let getCountryForNumber = (rawValue, countryCode = 'PL') => {
            let parsedPhoneNumber = parsePhoneNumber(rawValue, countryCode)
            return parsedPhoneNumber && parsedPhoneNumber.country ? parsedPhoneNumber.country : null
        }

        let isValidNumber = (rawValue, countryCode = 'PL') => {
            let parsedPhoneNumber = parsePhoneNumber(rawValue, countryCode)
            if (!parsedPhoneNumber || typeof parsedPhoneNumber.isValid !== 'function') {
                return false
            }
            return parsedPhoneNumber.isValid()
        }

        let isPossibleNumber = (rawValue, countryCode = 'PL') => {
            let parsedPhoneNumber = parsePhoneNumber(rawValue, countryCode)
            if (!parsedPhoneNumber || typeof parsedPhoneNumber.isPossible !== 'function') {
                return false
            }
            return parsedPhoneNumber.isPossible()
        }

        let isAcceptableNumber = (rawValue, countryCode = 'PL') => {
            let parsedPhoneNumber = parsePhoneNumber(rawValue, countryCode)
            if (!parsedPhoneNumber) {
                return false
            }

            let isValid = typeof parsedPhoneNumber.isValid === 'function' && parsedPhoneNumber.isValid()
            if (isValid) {
                return true
            }

            return typeof parsedPhoneNumber.isPossible === 'function' && parsedPhoneNumber.isPossible()
        }

        return {
            formatAsYouType: formatAsYouType,
            formatDisplayValue: formatForDisplay,
            formatForDisplay: formatForDisplay,
            formatForInput: formatForInput,
            getCountryForNumber: getCountryForNumber,
            getCountryCallingCode: getCountryCallingCode,
            isFreeTextValue: isFreeTextValue,
            isInternationalNumber: isInternationalNumber,
            isAcceptableNumber: isAcceptableNumber,
            isPossibleNumber: isPossibleNumber,
            isValidNumber: isValidNumber,
            normalizeForCompare: normalizeForCompare,
            normalizeCountryCode: normalizeCountryCode,
            parsePhoneNumber: parsePhoneNumber
        }
    })
    .filter('phoneNumberFormat', function (PhoneNumberFormatter) {
        return function (input, countryCode) {
            return PhoneNumberFormatter.formatForDisplay(input, countryCode)
        }
    })
